"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconTag = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconTag = function SvgIconTag(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0H3a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V3a3 3 0 00-3-3zM6.393 2.5a.5.5 0 00-.5-.5h-.717a.5.5 0 00-.5.5v.863a.5.5 0 01-.5.5H3.5a.5.5 0 00-.5.5v.319a.5.5 0 00.5.5h.676a.5.5 0 01.5.5v2.523c0 .852.174 1.436.521 1.752.348.313 1.014.469 1.998.469h.942a.5.5 0 00.5-.5v-.319a.5.5 0 00-.5-.5h-.819c-.332 0-.57-.062-.714-.187-.141-.129-.211-.34-.211-.633V5.682a.5.5 0 01.5-.5h1.244a.5.5 0 00.5-.5v-.319a.5.5 0 00-.5-.5H6.893a.5.5 0 01-.5-.5V2.5z",
    fill: "currentColor"
  }));
};

exports.SvgIconTag = SvgIconTag;